import React, { useMemo } from "react";
import propTypes from "prop-types";
import "./index.scss";
import { useTranslation } from "../../i18n";

const OptionSelect = ({
  name,
  top,
  left,
  select,
  isReverse,
  stateSelectionType
}) => {
  const {
    _t
  } = useTranslation();
  const elements = useMemo(() => {
    switch (stateSelectionType) {
      case "ProstheticsPrepare":
        return [{
          id: "sealedCanal",
          img: require("../newProject/formula/icons/sealedCanal.png"),
          name: _t("Пломбированный канал")
        }, {
          id: "toothStumpRestoration",
          img: require("../newProject/formula/icons/toothStumpRestoration.png"),
          name: _t("Восстановление культи")
        }, {
          id: "stumpTabs",
          img: require("../newProject/formula/icons/stumpTabs.png"),
          name: _t("Культевая вкладка")
        }, {
          id: "emptyTooth",
          img: require("../newProject/formula/icons/toothRemoval.png"),
          name: _t("Удаление зуба")
        }, {
          id: "healthyTooth",
          img: require("../newProject/formula/icons/healthyTooth.png"),
          name: _t("Естественный зуб")
        }];

      case "TherapyPrepare":
        return [{
          id: "cariousTooth",
          img: require("../newProject/formula/icons/cariousTooth.png"),
          name: _t("Кариес")
        }, {
          id: "pulpitis",
          img: require("../newProject/formula/icons/pulpitis.png"),
          name: _t("Пульпит")
        }, {
          id: "badSealedCanal",
          img: require("../newProject/formula/icons/badSealedCanal.png"),
          name: _t("Плохо запломбированный канал")
        }, {
          id: "brokenToolCanal",
          img: require("../newProject/formula/icons/brokenToolCanal.png"),
          name: _t("Сломанный инструмент в канале")
        }, {
          id: "emptyTooth",
          img: require("../newProject/formula/icons/toothRemoval.png"),
          name: _t("Удаление зуба")
        }, {
          id: "healthyTooth",
          img: require("../newProject/formula/icons/healthyTooth.png"),
          name: _t("Естественный зуб")
        }];

      default:
        return [];
    }
  }, [_t, stateSelectionType]);
  return /*#__PURE__*/React.createElement("div", {
    className: "optionSelect",
    style: {
      left,
      top,
      zIndex: 12,
      transform: isReverse ? "translateY(-100%)" : "none"
    }
  }, elements.map(el => /*#__PURE__*/React.createElement("div", {
    key: el.id,
    className: "optionSelect-item",
    onClick: () => select(el.id, name)
  }, /*#__PURE__*/React.createElement("img", {
    src: el.img,
    alt: ""
  }), el.name)));
};

OptionSelect.propTypes = {
  name: propTypes.string.isRequired,
  top: propTypes.number.isRequired,
  left: propTypes.number.isRequired,
  select: propTypes.func.isRequired,
  isReverse: propTypes.bool.isRequired
};
export default OptionSelect;